import MobileAppIcon from "assets/svg/mobile-app-banner.svg";

import Container from "components/grid/container";
import { LazyImage } from "components/common/lazy-image/LazyImage";

import styles from "./styles.module.css";

const MobileAppBanner = () => {
  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.inner}>
          <div className={styles.content}>
            <h2 className={styles.title}>Emlakjet Uygulamasını İndirin</h2>
            <p className={styles.info}>
              İlanları mobil uygulamalardan kolayca takip et! Aradığın evi, işyerini ya da arsayı hemen bul!
            </p>
            <div className={styles.buttonWrap}>
              <a
                target="_blank"
                href="https://play.google.com/store/apps/details?id=com.emlakjet.kurumsal.sekizbit"
                rel="noreferrer"
              >
                <LazyImage src="/assets/images/mobile-app/google-play.png" alt="Emlakjet - Mobil Uygulama" />
              </a>
              <a target="_blank" href="https://apps.apple.com/us/app/emlakjet-i-lan-ver/id1194656334" rel="noreferrer">
                <LazyImage src="/assets/images/mobile-app/app-store.png" alt="Emlakjet - Mobil Uygulama" />
              </a>
            </div>
          </div>
          <div className={styles.banner}>
            {/* <MobileAppIcon /> */}
            <img src="/assets/images/app.webp" width="445" height="295" alt="Emlakjet - Mobil Uygulama" />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default MobileAppBanner;
